/*Customizations: 
gestione del cambio di lingua in siti multilingua, per ricaricare gli indici per i filtri nella lingua corretta
*/
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
//import { getQuerystring } from '@plone/volto/actions';
import { getQuerystring } from '@redturtle/volto-io-studio/actions/querystring'; //usa questa per avere la querystring bypath per funzionare bene con il multilinguismo
import { useLocation } from 'react-router';

import config from '@plone/volto/registry';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * A HOC that injects querystring metadata information from the backend.
 *
 */
export default function withQueryString(WrappedComponent) {
  function WithQueryString(props) {
    const dispatch = useDispatch();

    const location = useLocation();
    const intl = useIntl();
    const pathname = location.pathname;

    const qs = useSelector((state) => state.querystring);

    // This showed up after updating eslint-plugin-react-hooks
    // TODO: fix it properly
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const indexes = qs?.indexes || {};

    React.useEffect(() => {
      const lrf = config.settings.isMultilingual ? '/' + intl.locale : '/';
      dispatch(getQuerystring(lrf));
    }, [intl.locale]);

    return <WrappedComponent {...props} querystring={qs} />;
  }
  WithQueryString.displayName = `WithQueryString(${getDisplayName(
    WrappedComponent,
  )})`;
  return WithQueryString;
}
